import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { FailedSolutions } from './components/FailedSolutions';
import { ProductIntro } from './components/ProductIntro';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsItFor } from './components/WhoIsItFor';
import { ExpectedResults } from './components/ExpectedResults';
import { FAQ } from './components/FAQ';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#0a0a0a] text-white font-sans selection:bg-cyan-500/30 selection:text-cyan-100" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainPoints data-id="element-2" />
      <FailedSolutions data-id="element-3" />
      <ProductIntro data-id="element-4" />
      <WhatYouGet data-id="element-5" />
      <WhoIsItFor data-id="element-6" />
      <ExpectedResults data-id="element-7" />
      <FAQ data-id="element-8" />
      <Testimonials data-id="element-9" />
      <Guarantee data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}